import { jsx as _jsx } from "react/jsx-runtime";
import { RemovableCard } from '@dixa/lib-shared-habla';
import isEqual from 'lodash/isEqual';
import { PureComponent } from 'react';
import { TagsSelect } from 'fable/tagsSelect/containers/tagsSelect';
import { withSelection, } from 'hocs/selection/withSelection';
import styles from '../bulkActionsModal.module.scss';
class BulkActionsTag extends PureComponent {
    componentDidUpdate({ selection: prevSelection }) {
        const { selection, onSelectionChanged } = this.props;
        if (!isEqual(selection.selectedItems, prevSelection.selectedItems)) {
            onSelectionChanged(selection.selectedItems);
        }
    }
    render() {
        const { onRemove, selection, title, allowCreatingNewTag = false, } = this.props;
        const { deselectItem, selectItem, selectedItems } = selection;
        return (_jsx(RemovableCard, Object.assign({ className: styles.actionCard, icon: "tag", title: title, onRemove: onRemove }, { children: _jsx(TagsSelect, { allowCreatingNewTag: allowCreatingNewTag, deselectTag: deselectItem, selectTag: selectItem, selectedItems: selectedItems, buttonText: "Select tag" }) })));
    }
}
const BulkActionsTagWithSelection = withSelection(BulkActionsTag);
export { BulkActionsTagWithSelection as BulkActionsTag };
